import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  public setItem(key: string, value: unknown) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  public getItem(key: string): unknown {
    const value = localStorage.getItem(key);
    if (value && value !== 'undefined' && value !== 'null') {
      return JSON.parse(value);
    } else {
      return null;
    }
  }

  public removeItem(key: string): void {
    localStorage.removeItem(key);
  }
}
